/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowFatLineDown(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M229.65723,141.65723l-96,96a8.003,8.003,0,0,1-11.31446,0l-96-96A8.00065,8.00065,0,0,1,32,128H72V72a8.00039,8.00039,0,0,1,8-8h96a8.00039,8.00039,0,0,1,8,8v56h40a8.00066,8.00066,0,0,1,5.65723,13.65723ZM184,40a8.00039,8.00039,0,0,0-8-8H80a8,8,0,0,0,0,16h96A8.00039,8.00039,0,0,0,184,40Z" />
    </Svg>
  );
}

export default ArrowFatLineDown;
